import { WhatYouGetCardInterface } from '@/types/newTypes'
import clsx from 'clsx'
import React from 'react'
import { useTheme } from '@/components/ThemeProvider'

const WhatYouGetBrand = () => {
  const { theme } = useTheme()
  const items: WhatYouGetCardInterface[] = [
    {
      img: '/img/what-you-get/1-new.webp',
      text: 'Fun Swipe-to-Clean Interface',
      gradient: 'red',
    },
    {
      img: '/img/what-you-get/2-new.webp',
      text: 'Smart Cleanup Suggestions',
      gradient: 'purple',
    },
    {
      img: '/img/what-you-get/3-new.webp',
      text: 'One-Tap Cleanup',
      gradient: 'yellow',
    },
    {
      img: '/img/what-you-get/4-new.webp',
      text: 'Duplicate Photo Detection',
      gradient: 'blue',
    },
    {
      img: '/img/what-you-get/5-new.webp',
      text: 'Secret Folder',
      gradient: 'red',
    },
    {
      img: '/img/what-you-get/6-new.webp',
      text: 'Widgets',
      gradient: 'purple',
    },
    {
      img: '/img/what-you-get/7-new.webp',
      text: 'Ad Blocker',
      gradient: 'yellow',
    },
    {
      img: '/img/what-you-get/8-new.webp',
      text: 'Charger Animation',
      gradient: 'blue',
    },
  ]

  return (
    <section className="flex mb-8 flex-col gap-6 pt-[21px] relative before:absolute before:max-w-[calc(100%+2rem)] dark:before:max-w-[calc(100%+2rem)] dark:before:w-[560px] before:w-screen dark:before:aspect-[1/1] before:aspect-[375/426] before:-top-0 before:z-[-1] before:bg-[position:center_bottom] before:left-1/2 before:-translate-y-[84%] dark:before:-translate-y-full before:-translate-x-1/2 before:bg-whatYouGetBg before:bg-no-repeat before:bg-[size:100%_auto]">
      <h2 className="text-center text-XL font-bold px-4">What you get?</h2>
      <div className="before:bg-[size:100%_auto] relative grid grid-cols-1 max-small:place-items-center small:grid-cols-2 dark:gap-x-[15px] dark:gap-y-[15px] gap-x-[15px] gap-y-[23px]  max-w-full mx-auto w-full before:absolute dark:before:min-w-[401px] dark:before:max-w-[430px] before:min-w-screen before:max-w-[430px] before:w-screen before:aspect-[367/916] dark:before:aspect-[401/1000] dark:before:top-0 before:-top-10 before:z-[-1] before:bg-center before:left-1/2 before:-translate-x-1/2 before:bg-whatYouGetBgAfter before:bg-no-repeat">
        {items.map((item, index) => (
          <div
            key={index}
            className={clsx(
              'relative dark:h-[136px] dark:mb-7 rounded-t-3xl rounded-b-2xl  min-h-[166px] before:backdrop-blur-[24px] before:absolute before:h-[164px] before:content-[""] before:left-0 before:right-0 before:top-0  before:bg-borgerLightGradient before:rounded-t-3xl',
              {
                'unset-bg': theme === 'light',
              },
            )}
          >
            <div
              className="relative z-[2] shadow-[0px 0px 16px 0px #00000033] dark:shadow-none m-px bg-[#E5E8FE] dark:bg-whiteBlack rounded-t-3xl rounded-b-2xl"
              style={{
                backgroundImage: clsx({
                  'linear-gradient(180deg, rgba(14, 14, 15, 0.24) 0%, rgba(219, 42, 48, 0.3) 100%)':
                    item.gradient === 'red' && theme === 'dark',
                  'linear-gradient(180deg, rgba(14, 14, 15, 0.24) 0%, rgba(133, 14, 147, 0.4) 100%)':
                    item.gradient === 'purple' && theme === 'dark',
                  'linear-gradient(180deg, rgba(14, 14, 15, 0.24) 0%, rgba(219, 154, 0, 0.3) 100%)':
                    item.gradient === 'yellow' && theme === 'dark',
                  'radial-gradient(86.94% 86.96% at 40.55% 28.01%, rgba(39, 201, 119, 0.5) 0%, rgba(39, 201, 119, 0) 100%), rgba(255, 255, 255, 0.08)':
                    item.gradient === 'green' && theme === 'dark',
                  'linear-gradient(180deg, rgba(14, 14, 15, 0.24) 0%, rgba(29, 43, 219, 0.4) 100%)':
                    item.gradient === 'blue' && theme === 'dark',
                }),
              }}
            >
              <div className="h-[136px] flex items-center justify-center z-[3] relative">
                <img
                  className="max-w-full w-auto h-auto object-contain"
                  src={item.img}
                  alt={item.text}
                />
              </div>
              <p className="text-center -mt-px -mx-px dark:-mb-14 -mb-2 z-[3] relative text-logo justify-center flex items-center p-2 px-3 leading-snug rounded-2xl bg-whiteBlack min-h-14">
                {item.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default WhatYouGetBrand
